"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformerList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Contexts_1 = require("../Contexts");
var DomList_1 = require("../core/list/dom/DomList");
var Ioc_1 = require("../utilities/Ioc");
var PerformerListLayoutProps_1 = require("./PerformerListLayoutProps");
var PerformerList = function (props) {
    var layout = props.layout, dataSource = props.dataSource, itemRenderer = props.itemRenderer;
    var layoutFromProps = (0, PerformerListLayoutProps_1.getLayoutFromLayoutProps)(layout);
    var _a = __read((0, Ioc_1.useContexts)(Contexts_1.IPerformerListListComponentTypeContext, Contexts_1.IThemeContext, Contexts_1.ITranslationServiceContext), 1), List = _a[0];
    var ListComponent = List !== null && List !== void 0 ? List : DomList_1.DomList;
    return (
    // we are setting direction to "rtl" at the top level - html tag - in SCP
    // to support right-to-left languages like Hebrew.
    // however, search grid itself doesn't need to be transformed, and we are setting it to "ltr".
    (0, jsx_runtime_1.jsx)("div", { "data-ta-locator": "PerformerList", style: { direction: "ltr" }, children: (0, jsx_runtime_1.jsx)(ListComponent, { dataSource: dataSource, layout: layoutFromProps.layout, layoutOptions: layoutFromProps.options, itemRenderer: itemRenderer, autoRefreshIntervalMs: 10000, viewportOverscan: {
                left: 0,
                top: window.innerHeight,
                bottom: window.innerHeight,
                right: 0,
            } }) }));
};
exports.PerformerList = PerformerList;
exports.PerformerList.displayName = "PerformerList";
//# sourceMappingURL=PerformerList.js.map